export const environment = {
  production: false,
  baseUrl: '',

  api_cns_portal: '/sicns',
  api_java_auth: '/registro-api/auth',

  api_java_consulta_lista_servicos: '/registro-api/api/registro/lista/servicos',
  api_java_busca_contrato_registro: '/registro-api/api/busca/contrato',
  api_java_consulta_restrito_fug: '/registro-api/api/perfil/restrito/fug',
  api_java_consulta_restrito_iso: '/registro-api/api/perfil/restrito/iso',
  api_java_grava: '/registro-api/api/certificado/grava',
  api_java_renova: '/registro-api/api/certificado/renova',
  api_java_auth_impressao: '/impressao-api/auth',
  api_java_servico_impressao: '/impressao-api/api/impressao',

  //criado para migração do ORDS *********
  api_java_cert_bloq: '/common-api/api/common/bloqueio/certificado/',
  api_java_consulta_situacao_cert: '/common-api/api/common/consulta/numeroSerial/',
  //*************************************
  
api_java_verifica_lcr: '',//deixando para testar mas não existe esse endpoint no registro

  api_node: '/cns-node/',

  //manual
  manual_cns: '/ajuda/#/menu-ajuda',
  
  st_nonce_ini: '6cb82f6066b8723395d49df1699b2eed3a5eb124',
  st_nonce_fim: '31e75df010e7dc7cd1e30dcf754d3ac7fb0d3345',

  

  api_download_kriptonita: 'https://www.caixa.gov.br/Downloads/fgts-conectividade-social/installcriptocns.zip',
  


};
